<template>
  <modal
    title="Override Membership Opportunity"
    class-name="membership-opportunity-modal"
    :cancel-button="true"
    :saving="saving"
    @submit="handleSave"
    @hide-modal="$emit('hide-modal')"
  >
    <div>
      <WarningMessage>
        The Membership Opportunity is used to calculate several metrics within
        your Sera account.
        <br />
        Changes to the Membership Opportunity will not be overridden by Sera in
        the future.
      </WarningMessage>
      <Select
        v-model="formData.membership_opportunity"
        name="Membership Opportunity"
        :options="options"
        :error-message="firstErrorMessage(v$.membership_opportunity)"
        placeholder="Select Membership Opportunity"
        label="Membership Opportunity"
        class="mb-2"
        full-width
        data-cy="membership-opportunity-select-input"
      />
    </div>
  </modal>
</template>

<script setup lang="ts">
import WarningMessage from "serviceshift-ui/components/General/WarningMessage.vue";
import { computed, ref } from "vue";
import { useStore } from "vuex";
import { EventBus } from "@/lib/event_bus.js";
import { firstErrorMessage } from "@/lib/vuelidate_helpers";

import Modal from "@/components/Modal.vue";
import { useVuelidate } from "@vuelidate/core";
import { required } from "@vuelidate/validators";

const store = useStore();

const props = defineProps<{
  updateUrl: string;
  membershipOpportunity: boolean;
}>();

const emit = defineEmits(["hide-modal", "save-success"]);
const saving = ref(false);

const formData = ref({
  membership_opportunity: props.membershipOpportunity.toString()
});

const options = computed(() => {
  return [
    { value: "true", label: "Yes" },
    { value: "false", label: "No" }
  ];
});

const v$ = useVuelidate(
  {
    membership_opportunity: { required }
  },
  formData.value
);

async function handleSave() {
  const valid = await v$.value.$validate();
  if (!valid) return;
  saving.value = true;
  try {
    await store.dispatch("setMembershipOpportunity", {
      url: props.updateUrl,
      ...formData.value
    });
    window.notify.success("Membership opportunity updated successfully!");
    emit("save-success");
    emit("hide-modal");
    EventBus.$emit("refresh-datatable");
  } catch (e) {
    console.error(e);
  } finally {
    saving.value = false;
  }
}
</script>

<style lang="scss">
.membership-opportunity-modal {
  .modal-dialog {
    max-width: 500px;
  }
}
</style>
